/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';

import EnvironmentService from 'cio/services/environment';
import AnalyticsService from 'cio/services/analytics';
import { IntegrationSnippetType } from 'cio/utils/analytics/transforms/integrations';
import joinWords from 'cio/utils/join-words';

export default class SetupGuideSourcesSnippet extends Component {
  @service environment!: EnvironmentService;
  @service analytics!: AnalyticsService;

  @tracked isShowingInstructions = false;

  @computed('environment.current.enabledIdentifiers.[]')
  get multiIdUsageComment() {
    let { enabledIdentifiers } = this.environment.current;

    return `Use ${enabledIdentifiers.length > 1 ? 'either ' : ''}${joinWords(enabledIdentifiers, ', ', ' or ')}.`;
  }

  @action
  toggleInstructions() {
    this.isShowingInstructions = !this.isShowingInstructions;
    if (this.isShowingInstructions) {
      this.analytics.track('onboarding', 'integration_details_clicked', { type: 'js' });
    }
  }

  @action
  onCopy(type: IntegrationSnippetType) {
    this.analytics.track('integration', 'api_credentials_copied', {
      credentialType: 'JavaScript',
      credentialCopied: type === 'js_snippet' ? 'JS Snippet' : 'JS Identify',
      source: 'Setup Guide (JS Snippet Source)',
    });
  }
}
